import React, { useState } from "react";
import styled from "styled-components";
import { FiEye, FiEyeOff } from "react-icons/fi";

const Wrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;

  /* O input renderizado (via inputAs) preenche o wrapper e abre espaco pro icone */
  & > input {
    margin: 0;
    width: 100%;
    padding-right: 40px;
  }
`;

const ToggleButton = styled.button`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  color: #002e3b;

  &:hover {
    color: ${(props) => props.$hoverColor || "#6ab8a8"};
  }
`;

const PasswordInput = ({
  inputAs = "input",
  hoverColor,
  className,
  ...inputProps
}) => {
  const [mostrar, setMostrar] = useState(false);
  const InputComponent = inputAs;

  return (
    <Wrapper className={className}>
      <InputComponent {...inputProps} type={mostrar ? "text" : "password"} />
      <ToggleButton
        type="button"
        onClick={() => setMostrar((v) => !v)}
        aria-label={mostrar ? "Ocultar senha" : "Mostrar senha"}
        title={mostrar ? "Ocultar senha" : "Mostrar senha"}
        tabIndex={-1}
        $hoverColor={hoverColor}
      >
        {mostrar ? <FiEyeOff size={18} /> : <FiEye size={18} />}
      </ToggleButton>
    </Wrapper>
  );
};

export default PasswordInput;
